module.exports = __webpack_public_path__ + "img/telegram-logo-16x16.00aebf13.svg";